// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__azgSj","content":"styles_content__3O5_o","selectAll":"styles_selectAll__3eHMM"};